<template>
    <div class="divider">
        <text-decorator class="divider-text">
            Chat toegewezen aan
            <text-decorator bold>
                {{ handoverReferredTo }}
            </text-decorator>
            door
            <text-decorator bold>
                {{ handoverReferredBy }}
            </text-decorator>
        </text-decorator>
    </div>
</template>

<script setup lang="ts">
    import { Interaction, User } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { onMounted, ref } from 'vue';

    const { client } = useClient();
    const props = defineProps<{
        interaction: Interaction
    }>();

    const handoverReferredTo = ref('');
    const handoverReferredBy = ref('');

    onMounted(async () => {
        if (props.interaction.handoverReferredTo?.id) {
            const user = await client.get(User, props.interaction.handoverReferredTo.id);
            handoverReferredTo.value = user.name.firstName ?? '';
        }

        if (props.interaction.handoverReferredBy?.id) {
            const user = await client.get(User, props.interaction.handoverReferredBy.id);
            handoverReferredBy.value = user.name.firstName ?? '';
        }
    });
</script>

<style scoped lang="scss">
.divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 16px 0;
}

.divider::before,
.divider::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
}

.divider-text {
    padding: 0 12px;
}
</style>
